<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <ExecutionPeriodFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import ExecutionPeriodFormPart from '~/components/form/parts/executionPeriod/ExecutionPeriodFormPart.PD-10940'
import NextStep from '~/pages/offertes-aanvragen/geschat-aantal-ramen'

export default {
  name: 'ExecutionPeriodFormStep',

  components: {
    ExecutionPeriodFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  data: () => ({
    willTransitionOnValid: true,
  }),

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
